import clsx from "clsx";
import React, { FunctionComponent, SVGProps } from "react";

export const EnvelopeFilledIcon: FunctionComponent<SVGProps<SVGSVGElement>> = ({
  className,
  ...props
}) => {
  return (
    <svg
      {...props}
      className={clsx("tw-icon", className)}
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="m22.58 7.892-9.74-4.813a.768.768 0 0 0-.68 0L2.423 7.892a.75.75 0 0 0-.422.67V20.25a.755.755 0 0 0 .759.75H22.24a.754.754 0 0 0 .759-.75V8.563a.75.75 0 0 0-.42-.671ZM12.5 4.589l8.11 4.005-8.237 4.067-8.109-4.005L12.5 4.59Z"
        fillRule="evenodd"
      />
    </svg>
  );
};
